import { CheckCircle, ErrorOutline, HideSource, RadioButtonUnchecked } from '@mui/icons-material'
import { Box, SxProps, Theme } from '@mui/material'

export type TickListValue = boolean | null | undefined
export type TickListProps = {
  names: string[]
  states: TickListValue[]
  sx?: SxProps<Theme>
}

export function TickList(props: TickListProps): React.ReactElement {

  const { names, states, sx } = props

  const cy = (state: any) => {
    if (state === undefined) {
      return 'canceled'
    }
    if (state === null) {
      return 'busy'
    }
    if (state === true) {
      return 'ok'
    }
    if (state === false) {
      return 'failed'
    }
  }

  return (
    <Box sx={{ textAlign: 'left', ...sx }}>
      {names.map((name, i) => {
        return <Box key={i} sx={{ whiteSpace: 'nowrap' }} data-cy={`TickLine-${cy(states[i])}-${name}`}>
          <Box sx={{ display: 'inline-block', mr: 1, verticalAlign: 'top' }}>
            {states[i] === undefined && <HideSource sx={{ color: 'rgba(255,255,255,0.2)' }}/>}
            {states[i] === null && <RadioButtonUnchecked/>}
            {states[i] === true && <CheckCircle sx={{ color: 'success.main' }}/>}
            {states[i] === false && <ErrorOutline sx={{ color: 'error.main' }}/>}
          </Box>
          <Box sx={{
            whiteSpace: 'normal',
            display: 'inline-block',
            color: states[i] === true ? 'success.main' : (states[i] === false ? 'error.main' : (states[i] === undefined ? 'rgba(255,255,255,0.2)' : ''))
          }}>
          {name}
          </Box>
        </Box>
      })}
    </Box>
  )
}
